module.exports = __webpack_public_path__ + "static/media/baloons_small.ac518ad6.jpg";